import { useTerritoryTableCell } from './territory-title-table-cell.model'
import type { ITerritoryTitleTableCell } from './territory-title-table-cell.types'
import { TerritoryTableCellView } from './territory-title-table-cell.view'

export function TerritoryTitleTableCell(props: ITerritoryTitleTableCell) {
  const viewProps = useTerritoryTableCell(props)

  return <TerritoryTableCellView {...viewProps} />
}
